<template>
  <button type="button"
          v-if="showButton === true"
          @click.prevent="onClick"
          class="e-button-delete row-delete"
  >{{label}}</button>
</template>

<script>
  import buttonMixin from './button-mixin.js'
  import {PERMS} from '../../config/permissions.js'

  export default {
    mixins: [buttonMixin],
    name: 'e-button-delete',
    props: {
      checkPerms: {
        type: Array,
        default: function () {
          return [PERMS.DELETE]
        }
      }
    },
    methods: {
      onClick ($event) {
        this.$emit('click', $event)
      }
    }
  }
</script>
